////AddRobot.js
//import React, { useState, useEffect } from 'react';
//import "../../Assets/Styles/Form.css";
//import Axios from 'axios';
//import * as FaIcons from "react-icons/fa";
//import { hasJWTToken } from "../Account/RouteGuard";
//import Select from 'react-select';
//import Form from 'react-bootstrap/Form';
//import AxiosInstance from '../Axios/AxiosInstance';
//export const PlantBlock = () => {
//    //alert(pid);
//    const _userID = sessionStorage.getItem("user_id");
//    const role_id = sessionStorage.getItem("role_id");
//    let _token = sessionStorage.getItem("token");
//    if (_token) _token = "Token exists";
//    let [responseData, setResponseData] = useState([]);
//    const [plantOption, setPlantOption] = useState([]);
//    const [selectedOption, setSelectedOption] = useState(null);
//    let [formData, setFormData] = useState({
//        plant_id: null,
//        block_id: null,
//        block_name: '',
//        user_id: _userID,
//        jwt_token: _token,
//        block_mode: 'Insert',
//        message: '',
//    });

//    const [errors, setErrors] = useState({});
//    const handleChange = (e) => {
//        const { name, value } = e.target;
//        setFormData({
//            ...formData,
//            [name]: value,
//        });
//    };

//    const handleSubmit = (e) => {
//        e.preventDefault();
//        var newErrors = validateForm(formData);
//        setErrors(newErrors);
//        if (Object.keys(newErrors).length === 0) {
//            formData.block_mode = "Insert";
//            formData.user_id = 1;
//            try {
//                let objBlockData = AxiosInstance.post("/PlantBlock", formData)
//                formData.block_id = null;;
//                formData.block_name = '';
//                formData.message = "Added new block successfully!";
//                console.log('Form submitted successfully!');
//            }
//            catch (error) {
//                console.log(error)
//            }

//        } else {
//            formData.message = 'Block submission failed due to validation errors.'
//            console.log('Form submission failed due to validation errors.');
//        }
//    };

//    const validateForm = (data) => {
//        const errors = {};
//        if (!data.plant_id.trim()) {
//            errors.plant_id = 'Plant ID is required';
//        } else if (data.plant_id.length > 10) {
//            errors.plant_id = 'Plant ID should not be less than or more than 10 digits';
//        }

//        if (!data.block_name.trim()) {
//            errors.block_name = 'Block name is required';
//        } else if (data.block_name.length > 50) {
//            errors.block_name = 'Block name should not be less than or more than 50 characters';
//        }
//        return errors;
//    };
//    const handleSelectChange = (e) => {
//        formData.plant_id = e.target.value;
//    };
//    useEffect(() => {
//        fetchPlantList();
//        var blockId = sessionStorage.getItem("editBlockId");
//        //  alert(blockId);
//        formData.block_id = blockId;
//        formData.plant_id = 1;
//        setFormData(formData);

//    }, [])
//    useEffect(() => {
//        console.log(plantOption)
//    }, [plantOption])
//    const fetchPlantList = async () => {
//        var userID = sessionStorage.getItem("user_id");
//        let response = await AxiosInstance.get("/DropDownList/GetPlantList?paramid=1&=uid=" + userID + "&pn=PlantList&dn=PlantList");
//        setPlantOption(response.data);
//    }
//    return (
//        <>
//            {hasJWTToken()  ? (
//            <div className="container-ul">
//                <div className="form-container">
//                    <h2 className="form-title"><FaIcons.FaRegEdit /> Add New Block</h2>
//                    <span className="form-message">
//                        {formData.message}
//                    </span>
//                    <form onSubmit={handleSubmit}>
//                        <div>
//                            <Form.Select name="plant_id" onChange={handleSelectChange}>
//                                {plantOption.map(opt => (
//                                    <option value={opt.plant_id}>{opt.plant_name}</option>
//                                ))}
//                            </Form.Select>
//                        </div>
//                        {/*<div>*/}
//                        {/*    <input*/}
//                        {/*        className="form-input"*/}
//                        {/*        type="number"*/}
//                        {/*        maxLength="10"*/}
//                        {/*        name="plant_id"*/}
//                        {/*        value={formData.plant_id}*/}
//                        {/*        onChange={handleChange}*/}
//                        {/*        placeholder="Enter plant ID (Max limit 10 digits)"*/}
//                        {/*    />*/}
//                        {/*    {errors.plant_id && (*/}
//                        {/*        <span className="error-message">*/}
//                        {/*            {errors.plant_id}*/}
//                        {/*        </span>*/}
//                        {/*    )}*/}
//                        {/*</div>*/}
//                        <div>
//                            <input
//                                className="form-input"
//                                type="text"
//                                name="block_name"
//                                maxLength="50"
//                                value={formData.block_name}
//                                onChange={handleChange}
//                                placeholder="Enter block name (Max limit 50 chars)"
//                            />
//                            {errors.block_name && (
//                                <span className="error-message">
//                                    {errors.block_name}
//                                </span>
//                            )}
//                        </div>
//                        <div class="row">
//                            <div class="col-9"><button className="submit-button" type="submit">Submit</button></div>
//                            <div class="col-3"><a className="btndelete" href="#/search-block">Search Block</a></div>
//                        </div>
//                    </form>
//                </div>
//            </div>
//        ) :
//            (
//                window.location.href = "#/Login"
//            )
//        }
//        </>
//    );
//}
//export default PlantBlock;

// AddRobot.js (PlantBlock Component)
// Responsible for adding a new plant block with validation and backend submission.

import React, { useState, useEffect } from "react";
import "../../Assets/Styles/Form.css";
import * as FaIcons from "react-icons/fa";
import { hasJWTToken } from "../Account/RouteGuard";
import Form from "react-bootstrap/Form";
import AxiosInstance from "../Axios/AxiosInstance";

export const PlantBlock = () => {

    const userID = sessionStorage.getItem("user_id");
    const role_id = sessionStorage.getItem("role_id");

    const [plantOption, setPlantOption] = useState([]);
    const [errors, setErrors] = useState({});

    // Controlled form state (never mutate directly)
    const [formData, setFormData] = useState({
        plant_id: "",
        block_id: null,
        block_name: "",
        user_id: userID,
        jwt_token: sessionStorage.getItem("token") ? "Token exists" : "",
        block_mode: "Insert",
        message: "",
    });

    // Input change handler
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    // Dropdown change
    const handleSelectChange = (e) => {
        const value = e.target.value;

        setFormData(prev => ({
            ...prev,
            plant_id: value
        }));
    };

    // Validate input fields
    const validateForm = (data) => {
        const err = {};

        if (!data.plant_id) {
            err.plant_id = "Plant ID is required";
        }

        if (!data.block_name.trim()) {
            err.block_name = "Block name is required";
        } else if (data.block_name.length > 50) {
            err.block_name = "Block name cannot exceed 50 characters";
        }

        return err;
    };

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = validateForm(formData);
        setErrors(newErrors);

        // Stop if validation fails
        if (Object.keys(newErrors).length > 0) {
            setFormData(prev => ({
                ...prev,
                message: "Validation failed. Please correct fields."
            }));
            return;
        }

        try {
            // Save block
            await AxiosInstance.post("/PlantBlock", {
                ...formData,
                block_mode: "Insert",
                user_id: userID,
            });

            // Reset form after success
            setFormData(prev => ({
                ...prev,
                block_name: "",
                message: "Block added successfully!"
            }));

            console.log("Block saved");

        } catch (error) {
            console.error(error);
            setFormData(prev => ({
                ...prev,
                message: "Error while saving block."
            }));
        }
    };

    // Fetch plant dropdown list
    const fetchPlantList = async () => {
        try {
            const response = await AxiosInstance.get(
                `/DropDownList/GetPlantList?paramid=1&uid=${userID}&pn=PlantList&dn=PlantList`
            );

            setPlantOption(response.data || []);
        } catch (error) {
            console.error("Plant list fetch failed", error);
        }
    };

    // Load once when page loads
    useEffect(() => {
        fetchPlantList();

        const blockId = sessionStorage.getItem("editBlockId");

        if (blockId) {
            setFormData(prev => ({
                ...prev,
                block_id: blockId
            }));
        }
    }, []);

    // Authorization guard
    if (!hasJWTToken()) {
        window.location.href = "#/Login";
        return null;
    }

    return (
        <div className="container-ul">
            <div className="form-container">

                <h2 className="form-title">
                    <FaIcons.FaRegEdit /> Add New Block
                </h2>

                <span className="form-message">{formData.message}</span>

                <form onSubmit={handleSubmit}>

                    {/* Plant Dropdown */}
                    <Form.Select name="plant_id" value={formData.plant_id} onChange={handleSelectChange}>
                        <option value="">-- Select Plant --</option>

                        {plantOption.map(opt => (
                            <option key={opt.plant_id} value={opt.plant_id}>
                                {opt.plant_name}
                            </option>
                        ))}
                    </Form.Select>
                    {errors.plant_id && (
                        <span className="error-message">{errors.plant_id}</span>
                    )}

                    {/* Block Name */}
                    <input
                        className="form-input"
                        type="text"
                        name="block_name"
                        value={formData.block_name}
                        onChange={handleChange}
                        maxLength="50"
                        placeholder="Enter block name"
                    />
                    {errors.block_name && (
                        <span className="error-message">{errors.block_name}</span>
                    )}

                    <div className="row">
                        <div className="col-9">
                            <button className="submit-button" type="submit">
                                Submit
                            </button>
                        </div>

                        <div className="col-3">
                            <a className="btndelete" href="#/search-block">
                                Search Block
                            </a>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default PlantBlock;
